export const CALCULATIONS_SHARED = {
    'CALCULATIONS.SHARED.MODIFY': 'Modifică',
    'CALCULATIONS.SHARED.MODIFY_FINAL_CREDIT': 'Modifică sold final credit',
    'CALCULATIONS.SHARED.FINAL_VALUE': 'Suma finală',
    'CALCULATIONS.SHARED.COMMENTS': 'Comentarii',
    'CALCULATIONS.SHARED.OVERFLOW_WARNING': 'Valoarea conține mai mult de 15 cifre',
    'CALCULATIONS.SHARED.TAKE_OVER_WARNING.MODAL.TITLE': 'Calcul preluat',
    'CALCULATIONS.SHARED.TAKE_OVER_WARNING.MODAL.MESSAGE': 'Calculul a fost preluat de un alt utilizator.',
    'CALCULATIONS.SHARED.TAKE_OVER_WARNING.MODAL.ACTION.GO_TO_CALCULATIONS': 'Mergi la calcule',
    'CALCULATIONS.SHARED.TAKE_OVER_WARNING.MODAL.ACTION.CONTINUE_IN_VIEW_MODE': 'Continuă în modul vizualizare'
};
